import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import React from 'react';

const LoadingComponent = () => {
    return (
        <DotLottieReact
            src='https://lottie.host/1e3783fa-9aa5-4eee-a16f-f7af5892fa33/OJxhAQMYSV.lottie'
            loop
            autoplay
            style={{
                width: 180,
                height: 180,
            }}
        />
    );
};

export default LoadingComponent;
